/*
 * BIFRI FIX: the theme's own cart-items/cart-drawer-items custom elements
 * guard their DOM refresh with `if (!this.lineItemContainer) return;`
 * (see updateQuantity() in shrine.null.js), but nothing in the theme ever
 * sets that property. That means every quantity change or removal DOES
 * update the cart on the server, but the visible cart drawer never
 * re-renders, so removed items appear to stay in the list.
 *
 * This restores the missing property without touching the core file.
 * Each cart section re-render replaces <cart-drawer-items>/<cart-items>
 * with a fresh element instance, so we re-apply on every 'cart-update'
 * pub/sub event the theme already publishes (once the guard above stops
 * blocking it).
 */
(function () {
  function patchLineItemContainers() {
    document.querySelectorAll('cart-items, cart-drawer-items').forEach(function (el) {
      if (!el.lineItemContainer) {
        el.lineItemContainer = el;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchLineItemContainers);
  } else {
    patchLineItemContainers();
  }

  function trySubscribe() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(patchLineItemContainers, 0);
      });
      return true;
    }
    return false;
  }

  if (!trySubscribe()) {
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      if (trySubscribe() || attempts > 20) clearInterval(retry);
    }, 100);
  }
})();

/*
 * BIFRI FIX 2 (revised): adding a toggle-style cart upsell, or the main
 * "Dodaj do koszyka" button, submits the theme's own product-form. Its
 * handler only calls cart.renderContents(...) -- the step that redraws
 * the drawer -- when `cart.oseid` is a string of 200+ characters. That
 * value comes from setHeaderCartIconAccessibility(), which reads a
 * data-attribute off an unrelated <form> in the header icons area
 * (keyed by cart-drawer's own data-type="modal"); it has nothing to do
 * with whether the add actually worked, and on this store it is short,
 * so the drawer never redraws after an add.
 *
 * REVISION NOTE: an earlier version of this fix worked around the gate
 * with an independent, timer-based re-fetch that overwrote #CartDrawer.
 * That created real damage: it could race with the theme's own render
 * and with quantity-stepper updates, leaving stale `data-index` values
 * in the DOM that made Shopify reject later /cart/change.js calls with
 * "Parametr line jest nieprawidłowy" -- i.e. it broke removal. That
 * version is removed. Instead we make `cart.oseid` satisfy the theme's
 * own check, so the theme's own tested render path runs normally and
 * nothing else duplicates or races it.
 */
(function () {
  var PLACEHOLDER = new Array(210).join('a');

  function patchOseid() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && (!cartDrawer.oseid || cartDrawer.oseid.length < 200)) {
      cartDrawer.oseid = PLACEHOLDER;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchOseid);
  } else {
    patchOseid();
  }

  function trySubscribe() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(patchOseid, 0);
      });
      return true;
    }
    return false;
  }

  if (!trySubscribe()) {
    var attempts = 0;
    var retry = setInterval(function () {
      attempts++;
      if (trySubscribe() || attempts > 20) clearInterval(retry);
    }, 100);
  }
})();

/*
 * BIFRI POPRAWKA 23.09.2026 (A): ciemna poswiata po zamknieciu koszyka.
 * Na iOS Safari zamkniety koszyk (visibility: hidden + polprzezroczyste
 * czarne tlo na calym ekranie) potrafil zostac namalowany az do zmiany
 * strony. CSS w bifri-fixes.css czysci tlo zamknietego koszyka; tutaj
 * dodatkowo po zamknieciu zdejmujemy blokade scrolla i wymuszamy
 * odmalowanie warstwy.
 */
(function () {
  function cleanupAfterClose() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || cd.classList.contains('active')) return;
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('overflow-hidden');
    cd.style.backgroundColor = 'transparent';
    var prev = cd.style.display;
    cd.style.display = 'none';
    void cd.offsetHeight;
    cd.style.display = prev;
  }

  function watchDrawer() {
    var cd = document.querySelector('cart-drawer');
    if (!cd || cd.__bifriOverlayWatch) return;
    cd.__bifriOverlayWatch = true;
    var wasActive = cd.classList.contains('active');
    new MutationObserver(function () {
      var isActive = cd.classList.contains('active');
      if (isActive) {
        cd.style.backgroundColor = '';
      } else if (wasActive) {
        setTimeout(cleanupAfterClose, 320);
      }
      wasActive = isActive;
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('cart-drawer .drawer__close, #CartDrawer-Overlay, .cart-drawer__overlay')) {
      setTimeout(cleanupAfterClose, 350);
    }
  }, true);
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') setTimeout(cleanupAfterClose, 350);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }
})();

/*
 * BIFRI POPRAWKA 23.09.2026 (B): wybor rozmiaru i koloru w pasku
 * "Dodaj do koszyka" na dole ekranu (telefon). Pasek nie ma wlasnej
 * logiki wariantow - rozwijane listy sterują glownymi kontrolkami strony
 * (lista "Rozmiar" i przyciski koloru bifri), wiec dalej dziala caly
 * dotychczasowy mechanizm (mapa produktow, zabezpieczenie wariantu przy
 * dodawaniu do koszyka).
 */
(function () {
  function getBar() {
    return document.querySelector('[data-bifri-sticky-atc]');
  }
  function getScope(bar) {
    return (bar && bar.closest('product-info')) || document;
  }
  function getSizeSelect(scope) {
    return scope.querySelector('variant-selects select') || scope.querySelector('select[name^="options["]');
  }
  function getColorButtons(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('[data-bifri-color]'));
  }
  function textOf(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function makeField(key, labelText) {
    var wrap = document.createElement('div');
    wrap.className = 'bifri-sticky-opt bifri-sticky-opt--' + key;
    var label = document.createElement('label');
    label.className = 'bifri-sticky-opt__label';
    label.setAttribute('for', 'BifriSticky-' + key);
    label.textContent = labelText;
    var select = document.createElement('select');
    select.className = 'bifri-sticky-opt__select';
    select.id = 'BifriSticky-' + key;
    select.setAttribute('data-bifri-sticky-' + key, '');
    wrap.appendChild(label);
    wrap.appendChild(select);
    return wrap;
  }

  function fillSelect(select, items, current) {
    var sig = JSON.stringify(items) + '|' + current;
    if (select.__bifriSig === sig) return;
    select.__bifriSig = sig;
    select.innerHTML = '';
    items.forEach(function (it) {
      var o = document.createElement('option');
      o.value = it.value;
      o.textContent = it.label;
      if (it.disabled) o.disabled = true;
      if (it.value === current) o.selected = true;
      select.appendChild(o);
    });
    select.value = current;
  }

  function refreshInfo(bar, scope) {
    try {
      var titleEl = bar.querySelector('.bifri-sticky-atc__title');
      var mainTitle = scope.querySelector('.product__title h1, .product__title h2, h1');
      if (titleEl && mainTitle && textOf(mainTitle)) titleEl.textContent = textOf(mainTitle);

      var priceWrap = bar.querySelector('.bifri-sticky-atc__price');
      var mainPrice = scope.querySelector('.price');
      if (priceWrap && mainPrice) {
        var onSale = mainPrice.classList.contains('price--on-sale');
        var current = onSale
          ? textOf(mainPrice.querySelector('.price__sale .price-item--sale'))
          : textOf(mainPrice.querySelector('.price__regular .price-item--regular'));
        var compare = onSale ? textOf(mainPrice.querySelector('.price__sale s, .price__compare-price .price-item--regular')) : '';
        var curEl = priceWrap.querySelector('.bifri-current-price');
        var sEl = priceWrap.querySelector('s');
        if (current && curEl) curEl.textContent = current;
        if (sEl) {
          if (compare) {
            sEl.textContent = compare;
            sEl.style.display = '';
          } else {
            sEl.style.display = 'none';
          }
        }
      }
    } catch (err) {}
  }

  function sync() {
    var bar = getBar();
    if (!bar) return;
    var scope = getScope(bar);
    var sizeSel = getSizeSelect(scope);
    var colorBtns = getColorButtons(scope);
    var wantSize = !!sizeSel && sizeSel.options.length > 1;
    var wantColor = colorBtns.length > 1;

    var box = bar.querySelector('.bifri-sticky-opts');
    if (!wantSize && !wantColor) {
      if (box) box.remove();
      bar.classList.remove('bifri-has-opts');
      return;
    }
    if (!box) {
      box = document.createElement('div');
      box.className = 'bifri-sticky-opts';
      bar.insertBefore(box, bar.firstChild);
    }
    bar.classList.add('bifri-has-opts');

    var sizeField = box.querySelector('.bifri-sticky-opt--size');
    if (wantSize) {
      if (!sizeField) {
        var labelSize = (sizeSel.name.match(/options\[(.+)\]/) || [])[1] || 'Rozmiar';
        sizeField = makeField('size', labelSize);
        box.insertBefore(sizeField, box.firstChild);
        sizeField.querySelector('select').addEventListener('change', function (e) {
          var main = getSizeSelect(getScope(getBar()));
          if (!main) return;
          main.value = e.target.value;
          main.dispatchEvent(new Event('change', { bubbles: true }));
          setTimeout(sync, 500);
        });
      }
      fillSelect(
        sizeField.querySelector('select'),
        Array.prototype.map.call(sizeSel.options, function (o) {
          return { value: o.value, label: textOf(o), disabled: o.disabled };
        }),
        sizeSel.value
      );
    } else if (sizeField) {
      sizeField.remove();
    }

    var colorField = box.querySelector('.bifri-sticky-opt--color');
    if (wantColor) {
      if (!colorField) {
        colorField = makeField('color', 'Kolor');
        box.appendChild(colorField);
        colorField.querySelector('select').addEventListener('change', function (e) {
          var btns = getColorButtons(getScope(getBar()));
          var target = btns.filter(function (b) {
            return b.getAttribute('data-bifri-color') === e.target.value;
          })[0];
          if (target && !target.classList.contains('active')) target.click();
          setTimeout(sync, 300);
          setTimeout(sync, 1000);
        });
      }
      var activeBtn = colorBtns.filter(function (b) { return b.classList.contains('active'); })[0] || colorBtns[0];
      fillSelect(
        colorField.querySelector('select'),
        colorBtns.map(function (b) {
          return { value: b.getAttribute('data-bifri-color'), label: textOf(b) || b.getAttribute('data-bifri-color') };
        }),
        activeBtn.getAttribute('data-bifri-color')
      );
    } else if (colorField) {
      colorField.remove();
    }

    refreshInfo(bar, scope);
  }

  function start() {
    if (!getBar()) return;
    sync();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-selects select, select[name^="options["]')) {
        setTimeout(sync, 400);
      }
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-bifri-color], [data-bifri-side]')) {
        setTimeout(sync, 400);
        setTimeout(sync, 1200);
      }
    });
    // Zabezpieczenie: gdyby motyw przerysowal pasek lub kontrolki
    setInterval(sync, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
